<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('wdc_course_list')" :isNewButton="false">
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('wdc_course_list')" :isNewButton="false">
				</HeaderMobile>
			</template>
			<datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
				:show-paginate="false" v-show="datatable.showTable">
			</datatable>
		</app-layout>
	</div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";

// Services

// Others

import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";
import getDayText from "@/helpers/getDayText";

export default {
	components: {
		AppLayout,
		Header,
		HeaderMobile,
		DatatableFilter,
		Datatable,
		CommonModal,
	},
	metaInfo() {
		return {
			title: this.$t('wdc_course_list')
		}
	},

	data() {
		return {
			datatable: {
				isLoading: false,
				columns: [
					{
						label: this.toUpperCase('id'),
						field: 'id',
						hidden: true,
					},
					{
						label: this.toUpperCase('course_code'),
						field: 'course_code',
						hidden: false,
					},
                    {
                        label: this.toUpperCase('course_name'),
                        field: this.getLocaleField('course_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('section'),
                        field: 'section',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('credit'),
                        field: 'course_credit',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('type'),
                        field: 'course_type_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('program_level'),
                        field: this.getLocaleField('program_level_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('modality'),
                        field: 'modality',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('course_schedule'),
                        field: 'course_schedules',
                        hidden: false,
                        formatFn: (value) => {
                            if (!value || !value.length) return '-';

                            return value
                                .map(s => `${this.getDayText(s.day)}: ${s.start_time} - ${s.end_time}`)
                                .join(', ');
                        },
                    },

				],
				rows: [],
				showTable: false,
			},
			formProcess: null,
			formId: null,
			form: {},
		}
	},
	created() {
        this.getRows()
	},
	methods: {
		filterClear() {
			this.getRows();
		},
		getRows() {
			this.datatable.showTable = true;
			this.datatable.isLoading = true;

			return CourseAgreementFormServices.courseList()
				.then((response) => {
					this.datatable.rows = response.data.data;
				})
				.finally(() => {
					this.datatable.isLoading = false;
				});
		},
	}
}
</script>

